import {useQuery} from "@tanstack/react-query";
import {toast} from "react-toastify";
import { statements } from '../../../api';

export const useGetStatements = () => {
    return useQuery(["admin-statements"], statements.get, {
        onError: (error) => {
            toast.error(error.response?.data?.message)
        },
    });
}
